<mat-toolbar
  *ngIf="!isOnParallaxChatRoute && !isOnMultiChatRoute"
  class="top-navbar-toolbar"
  [class.scrolled]="isScrolled"
  [class.collapsed]="isNavCollapsed"
  [class.hide-on-multichat]="isOnMultiChatRoute"
  [class.doublechat]="isOnCompareModeRoute"
  [class.clarichat]="isOnClariChatRoute">

  <div class="mat-toolbar-row top-navbar-row">
    <div class="navbar-branding">
      <ng-container *ngTemplateOutlet="clarichatBranding"></ng-container>

      <div
        class="model-name-container compare-model-left"
        *ngIf="showModelName2 && !isOnClariVideoRoute && compareLeftLetters.length > 0">
        <span
          class="model-name-gradient"
          (click)="openCompareModelSelector()"
          title="Pick left model">
          <span
            *ngFor="let letter of compareLeftLetters; let i = index"
            [class.model-name-letter]="!isModelNameSpacer(letter)"
            [class.model-name-space]="isModelNameSpacer(letter)"
            [style.--target-color]="!isModelNameSpacer(letter) ? getCompareLeftLetterColor(i) : undefined"
            [style.animationDelay]="!isModelNameSpacer(letter) ? getModelNameLetterDelay(i) : undefined">
            {{ letter }}
          </span>
        </span>
      </div>
    </div>

    <div class="navbar-right">
      <div class="top-right-section">
        <ng-container *ngTemplateOutlet="selectedModelBlock"></ng-container>

        <div
          class="model-name-container compare-model-right"
          *ngIf="showModelName2 && !isOnClariVideoRoute && compareRightLetters.length > 0">
          <span
            class="model-name-gradient"
            (click)="openCompareModelSelector()"
            title="Pick right model">
            <span
              *ngFor="let letter of compareRightLetters; let i = index"
              [class.model-name-letter]="!isModelNameSpacer(letter)"
              [class.model-name-space]="isModelNameSpacer(letter)"
              [style.--target-color]="!isModelNameSpacer(letter) ? getCompareRightLetterColor(i) : undefined"
              [style.animationDelay]="!isModelNameSpacer(letter) ? getModelNameLetterDelay(i) : undefined">
              {{ letter }}
            </span>
          </span>
        </div>

        <div class="auth-links">
          <ng-container *ngIf="authState$ | async; else loggedOutLinks">
            <div class="auth-links-group">
              <a
                class="auth-link"
                href=""
                role="button"
                (click)="logout($event)"
                (keydown.enter)="logout($event)"
                (keydown.space)="logout($event)">
                <span class="login">Logout</span>
              </a>
            </div>
          </ng-container>

          <ng-template #loggedOutLinks>
            <div class="auth-links-group">
              <a class="auth-link" routerLink="/auth/log-in">
                <span class="login">Log In</span>
              </a>
              <a class="auth-link" routerLink="/auth/signup">
                <span class="login">Sign Up</span>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</mat-toolbar>

<ng-template #clarichatBranding>
  <a
    id="brandingClariChat"
    class="navbar-title clickable"
    [routerLink]="isOnClariVideoRoute ? '/clari-video-chat' : '/clarichat'"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: false }"
    *ngIf="!isOnClariVideoRoute">
    <span class="cutepurple clari-gradient">
      <span
        *ngFor="let letter of brandLetters; let i = index"
        class="clari-letter"
        [style.--target-color]="getClariLetterColor(i)"
        [style.--transition-color]="getClariLetterTransitionColor(i)"
        [style.--clari-letter-delay]="getClariLetterDelay(i)">
        {{ letter }}
      </span>
    </span>
  </a>
</ng-template>

<ng-template #selectedModelBlock>
  <div
    class="model-name-container"
    *ngIf="showModelName && !isOnClariVideoRoute && selectedModelName && modelNameLetters.length > 0">
    <span
      class="model-name-gradient"
      (click)="openAiCatalog()"
      title="Select AI model">
      <span
        *ngFor="let letter of modelNameLetters; let i = index"
        [class.model-name-letter]="!isModelNameSpacer(letter)"
        [class.model-name-space]="isModelNameSpacer(letter)"
        [style.--target-color]="!isModelNameSpacer(letter) ? getModelNameLetterColor(i) : undefined"
        [style.animationDelay]="!isModelNameSpacer(letter) ? getModelNameLetterDelay(i) : undefined">
        {{ letter }}
      </span>
    </span>
  </div>
</ng-template>

<button
  class="nav-collapse-handle"
  (click)="toggleNavCollapse()"
  aria-label="Toggle navigation"
  data-tooltip="Toggle top nav">
  <i
    class="fas"
    [class.fa-chevron-up]="!isNavCollapsed"
    [class.fa-chevron-down]="isNavCollapsed">
  </i>
</button>
